<style>
    .tscroll {
        width: 100%;
        overflow-x: scroll;
        margin-bottom: 10px;
        border: solid black 1px;
    }

    .tscroll table td:first-child {
        position: sticky;
        left: 0;
        background-color: #ddd;
    }

    .tscroll table th:first-child {
        position: sticky;
        left: 0;
        background-color: #ddd;
    }

    .tscroll td,
    .tscroll th {
        border-bottom: dashed #888 1px;
        width: auto;
    }

    .tscroll table td:nth-child(2) {
        position: sticky;
        left: 4rem;
        background-color: #ddd;
    }

    .tscroll table th:nth-child(2) {
        position: sticky;
        left: 4rem;
        background-color: #ddd;
    }

    .col2 {
        z-index: 2;
    }

    .switch-form-control {
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.5;
        display: block;
        width: auto;
        height: calc(1.5em + 1.25rem + 2px);
        padding: 0.625rem 0.75rem;
        transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        color: #555;
        border: 1px solid #cccccc;
        border-radius: 0.25rem;
        background-color: #fff;
        background-clip: padding-box;
        box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
    }
</style>



<article>
    <!-- <input type="file" (change)="selectFile($event)">
    <button (click)="uploadExcelFile()">Upload</button> -->
  
    <div *ngIf="uploadType =='Import From Excel'">
        <div class="container">
            <span style="color: darkcyan;">While uploading data from Excel ,please make sure upload data format matches
                the
                format that can be downloaded from below.
            </span>
        </div>
    </div>
    <div class="header bg-white">
        <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-3 bg-head-light">
                    <div class="col-lg-6 col-5">
                        <h1 style="justify-content: center;" class="h3 mb-0"> Switch Transaction Entry</h1>
                    </div>
                    <div class="col-lg-6 col-7">
                        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4 float-right">
                            <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                                <li class="breadcrumb-item">
                                    <i class="fas fa-home"></i>
                                </li>

                                <li class="breadcrumb-item active" aria-current="page"> Switch Transaction Entry </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container1" appDnd (fileDropped)="onFileDropped($event)">
        <input type="file" #fileDropRef id="fileDropRef" (change)="addFile($event)" onclick="this.value=null;"
            class="input1"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
        <img alt="uploading..." class="upload" src="./assets/img/upload_excel.png" width="60" height="60">
        <h4>Drag and drop file here</h4>
        <h4>or</h4>
        <label class="label1" for="fileDropRef">Browse for file</label><br>
        <!-- <div class="py-3 bg-white my-3 mt-5" style="width: 1200px;">  -->

    </div>
    <div class="UploadFormat" style="text-align: center;">
        For Excel Format <br>
        <button class="btn btn-primary" (click)="export()">Click to download Upload Format</button> &nbsp;&nbsp;
    </div>
    <div class="files-list" *ngIf="fileLength > 0" style="max-width: 80%; margin-left: 10%;">
        <div class="single-file">
            <div class="file-icon" style="width: 50px;">
                <img alt="file Icon.." src="./assets/img/excel_file_icon.png" width="50" height="50" padding-down="30%">
            </div>
            <div class="info">
                <h4 class="name" style="right: margin 20px;;">
                    {{ files[0]?.name }}
                </h4>
                <p class="size">
                    {{ formatBytes(files[0]?.size) }}
                </p>
                <app-progress [progress]="files.progress"  ></app-progress>
            </div>
            <div class="delete" (click)="deleteFile()">
                <img alt="delete-icon..." src="./assets/img/delete_icon.png" width="50" height="50">
            </div>

        </div>
    </div>



    <div class="tscroll sheet-list-edit pb-4 border-0 mx-3" *ngIf="isShowTable">
        <form [formGroup]="registerForm" (ngSubmit)="uploadExcelFile()">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Merchant Id</th>
                        <th>Terminal Id</th>
                        <th>Merchant Name</th>
                        <th>Transaction Type</th>
                        <th>Response Code</th>
                        <th>Response Label</th>
                        <th>Reference Number</th>
                        <th>Currency Code</th>
                        <th>Transaction Amount</th>
                        <th>Transaction Date</th>
                        <th>Batch Number</th>
                        <th>Remarks</th>
                        <th>Card Type</th>
                        <th>Pos Entry Mode</th>
                        <th>Stan Number</th>

                    </tr>


                </thead>
                <tbody formArrayName="switchTransactionLogArray">
                    <ng-container
                        *ngFor="let switchTransaction of switchTransactionLogArray.controls |paginate: {itemsPerPage: 11, currentPage: p} ;  let i = index">
                        <tr [formGroupName]="i">

                            <td>
                                <input type="text" formControlName="merchantId" id="merchantId{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('merchantId')?.errors"
                                    style="color: red;">MerchantId is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="terminalId" id="terminalId{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('terminalId')?.errors"
                                    style="color: red;">TerminalId is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="merchantName" id="merchantName{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('merchantName')?.errors"
                                    style="color: red;">MerchantName is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="transactionType" id="transactionType{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('transactionType')?.errors"
                                    style="color: red;">TransactionType is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="responseCode" id="responseCode{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('transactionType')?.errors"
                                    style="color: red;">ResponseCode is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="responseLabel" id="responseLabel{{i}}"
                                    class="switch-form-control">
                                <span
                                    *ngIf="switchTransactionLogArray.controls[i].get('responseLabel')?.errors?.required"
                                    style="color: red;">ResponseLabel is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="referenceNumber" id="referenceNumber{{i}}"
                                    class="switch-form-control">
                                <span
                                    *ngIf="switchTransactionLogArray.controls[i].get('referenceNumber')?.errors?.duplicateReferenceNo"
                                    style="color: red;">Duplicate Reference number</span>
                                <span
                                    *ngIf="switchTransactionLogArray.controls[i].get('referenceNumber')?.errors?.referenceNumberValidationError"
                                    style="color: red;">{{switchTransactionLogArray.controls[i].get('referenceNumber')?.errors?.referenceNumberValidationError}}</span>
                                <span
                                    *ngIf="switchTransactionLogArray.controls[i].get('referenceNumber')?.errors?.required"
                                    style="color: red;">Reference Number is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="currencyCode" id="currencyCode{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('currencyCode')?.errors"
                                    style="color: red;">Currency Code is required.</span>
                            </td>
                            <td>
                                <input type="amount" formControlName="transactionAmount" id="transactionAmount{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('transactionAmount')?.errors"
                                    style="color: red;">Transaction Amount is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="transactionDate"
                                    [id]="'transactionDate' + (i | date:'yyyy-MM-dd HH:mm:ss')"
                                    class="switch-form-control">
                                <span *ngFor="let dateValue of dateValues">{{ dateValue | excelDate }}</span>
                                <span *ngIf="switchTransactionLogArray.controls[i].get('transactionDate')?.errors"
                                    style="color: red;">Transaction Date is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="batchNumber" id="batchNumber{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('batchNumber')?.errors"
                                    style="color: red;">Batch Number is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="remarks" id="remarks{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('remarks')?.errors"
                                    style="color: red;">Remarks is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="cardType" id="cardType{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('cardType')?.errors"
                                    style="color: red;">CardType is required.</span>
                            </td>

                            <td>
                                <input type="text" formControlName="posEntryMode" id="posEntryMode{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('posEntryMode')?.errors"
                                    style="color: red;">Pos Entry Mode is required.</span>
                            </td>
                            <td>
                                <input type="text" formControlName="stanNumber" id="stanNumber{{i}}"
                                    class="switch-form-control">
                                <span *ngIf="switchTransactionLogArray.controls[i].get('stanNumber')?.errors"
                                    style="color: red;">Stan Number is required.</span>
                            </td>


                    </ng-container>
                </tbody>

                <div class="py-3">
                    <button type="submit" class="btn btn-primary"
                        style="margin-left: 10px; right: 20px; position: absolute;"
                        [disabled]="submitted">Submit</button><br>
                </div>
                
            </table>
        </form>
        <pagination-controls style="font-size:12px" (pageChange)="p = $event"></pagination-controls>

    </div>
</article>
